enum NewsletterList {
  default = 'default',
  drama = 'drama',
  science = 'science',
  civics = 'civics'
}

export default NewsletterList
